import { createSelector } from 'reselect';

import getBuildCounts from '@/state/selectors/saved-builds/get-build-counts';

const getBuildCountsTotal = createSelector([getBuildCounts], (buildCounts) => {
	const keys = Object.values(buildCounts);
	if (keys.length === 0) return 0;

	return keys.reduce((acc, curr) => acc + curr);
});

export default getBuildCountsTotal;
